import { isApp } from "./isApp";
import { isIOS } from "./isIOS";

export function appDownloadUrl(url: string): string {
	return `aramcolife://download=${encodeURIComponent(url)}`;
}

export function openAppDownload(url: string): void {
	window.location.href = appDownloadUrl(url);
}

export function resolveDownloadUrl(url: string): string | null {
	try {
		return new URL(url, window.location.href).href;
	} catch {
		return null;
	}
}

export function openDownload(url: string): void {
	const resolved = resolveDownloadUrl(url);
	if (!resolved) {
		return;
	}

	if (isApp() && isIOS()) {
		openAppDownload(resolved);
		return;
	}

	const link = document.createElement("a");
	link.href = resolved;
	link.download = "";
	link.rel = "noopener noreferrer";
	link.hidden = true;
	document.body.appendChild(link);
	link.click();
	link.remove();
}
